import { IStandardApiError } from "./i-standard-api-error.js";
import { IExtendedApiResponse } from "./i-extended-api-response.js";
import { IExtendedApiError } from "./i-extended-api-error.js";

export async function checkStandardApiError(response: Response, throwErr: boolean = false, errorReporter: ((error: IStandardApiError) => void) | null = null): Promise<boolean> {
    let error: IStandardApiError & { Message: string, ExceptionMessage?:string} = null;

    if (!response.ok) {
        try {
            error = await response.json();

            if (!error.message && error.Message) {
                error.message = error.Message;
            }

            if (error.ExceptionMessage!=null) {
                error.exceptionMessage = error.ExceptionMessage;
            }

            if (error != null && errorReporter != null) {
                errorReporter(error);
            }
        }
        catch (e) {
            if (errorReporter) {
                errorReporter({ message: "A unknown error occurred while completing the request" });
            }
        }

        if (throwErr) {
            throw new Error(`Error in API call: ${error ? error.exceptionMessage || error.message : response.status}`);
        }

        return false;
    }

    return true;
}

export async function checkExtendedApiError(response: Response, throwErr: boolean = false, errorReporter: ((error: IExtendedApiError) => void) | null = null): Promise<boolean> {
    let apiResponse: IExtendedApiResponse<null> = null; //In case of any error outside TryAction - check IApiErrorDetails as well.

    if (!response.ok) {
        try {
            apiResponse = await response.json();

            if (apiResponse.hasError && apiResponse.errorMessage) {
                errorReporter(apiResponse);
            }
        }
        catch (e) {
            errorReporter({ errorMessage: "A unknown error occurred while completing the request" });
        }

        if (throwErr) {
            throw new Error(`Error in API call: ${apiResponse ? apiResponse.devErrorMessage || apiResponse.errorMessage : response.status}`);
        }

        return false;
    }

    return true;
}